import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { NormalSaveFlow } from './NormalSaveFlow'
import { RiskChangeSaveFlow } from './RiskChangeSaveFlow'

export default function SaveRetirementScenario (props) {
  const [riskChanged, setRiskChanged] = useState(false)
  const [scenarioName, setScenarioName] = useState(props.retirementScenarioName)
  const [sendImplementationNoticeToClient, setSendImplementationNoticeToClient] = useState(false)
  const [advisorDeclarationAcceptance, setAdvisorDeclarationAcceptance] = useState(false)

  const checkIfRiskRatingChanged = () => (
    parseFloat(props.currentRiskProfile.rating) !==
    parseFloat(props.newRiskProfile.rating)
  )

  return (
    <div className='save-scenario-dialog'>
      {
        riskChanged
          ? <RiskChangeSaveFlow
            scenarioName={scenarioName}
            setScenarioName={setScenarioName}
            sendImplementationNoticeToClient={sendImplementationNoticeToClient}
            setSendImplementationNoticeToClient={setSendImplementationNoticeToClient}
            advisorDeclarationAcceptance={advisorDeclarationAcceptance}
            {...props}
            />
          : <NormalSaveFlow
            scenarioName={scenarioName}
            setScenarioName={setScenarioName}
            setRiskChangedFlow={() => setRiskChanged(true)}
            checkIfRiskRatingChanged={checkIfRiskRatingChanged}
            sendImplementationNoticeToClient={sendImplementationNoticeToClient}
            setSendImplementationNoticeToClient={setSendImplementationNoticeToClient}
            advisorDeclarationAcceptance={advisorDeclarationAcceptance}
            setAdvisorDeclarationAcceptance={setAdvisorDeclarationAcceptance}
            {...props}
            />
      }
    </div>
  )
}

SaveRetirementScenario.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  method: PropTypes.string.isRequired,
  clientId: PropTypes.number.isRequired,
  retirementScenarioId: PropTypes.number,
  retirementScenarioName: PropTypes.string,
  isWealthManager: PropTypes.bool,
  canImplement: PropTypes.bool,
  riskChangedFlow: PropTypes.bool,
  currentRiskProfile: PropTypes.object.isRequired,
  newRiskProfile: PropTypes.object.isRequired
}
